// extracted by mini-css-extract-plugin
module.exports = {"buyOption":"_26Izp"};